import { useSelector } from 'react-redux';
import { filter, map, size } from 'lodash-es';
import { Link } from 'react-router-dom';

import { HomePageLoader, homeSelector, SortedVideosDecorated, VideoControlsMenu } from 'pages/home.page';
import { Carousel } from 'pages/home.page/video-carousel/carousel';
import { urlVideoIdSelector } from 'pages/channel.page';
import {
  channelsSelector,
  getContainerWideSelector,
  getRelatedVideosFeatureSelector,
  integrationSelector,
  sortedVideosSelector,
  websiteSelector,
  getRatingFeatureSelector,
} from 'common/selectors';
import { PageDecorated } from 'pages/page';
import { ContentBox } from 'components/content-box';
import { VideoBoxDecorated } from 'components/video-box';
import { videoBoxHomeRequestAction, videoBoxRequestAction } from 'components/video-box/actions';
import { isIframe } from 'integration/integration.utils';
import { Header } from 'components/header';
import { navigationItemModel } from 'common/api/models';
import { useMemo } from 'react';

export const HomePage = (props) => {
  const home = useSelector(homeSelector);
  const channels = useSelector(channelsSelector);
  const website = useSelector(websiteSelector);
  const videoId = useSelector((state) => urlVideoIdSelector(state, props.match));
  const withRelatedVideos = useSelector(getRelatedVideosFeatureSelector);
  const withRating = useSelector(getRatingFeatureSelector);
  const containerWide = useSelector(getContainerWideSelector);
  const integration = useSelector(integrationSelector);
  const sortedVideoLists = useSelector(sortedVideosSelector);

  const navItems = useMemo(() => {
    return home && home.length > 0
      ? map(
          filter(home, (c) => !!c.id),
          (collection) => ({
            collectionId: collection.id,
            model: navigationItemModel(channels.find((navItem) => navItem.id === Number(collection.id))),
          })
        )
      : [];
  }, [home, channels]);

  return (
    <PageDecorated hasVideoListArea="true" className="ct-home-page">
      <HomePageLoader>
        <VideoBoxDecorated
          playerConfiguration={website.playerConfiguration}
          videoBoxRequestAction={videoId ? videoBoxRequestAction(videoId) : videoBoxHomeRequestAction()}
          withRelatedVideos={withRelatedVideos}
          inlineVideoControls={VideoControlsMenu}
        />

        <div>
          {isIframe(integration) && <Header />}

          {size(home) > 0 ? (
            <ContentBox id="page-video-lists">
              <div className="ct-home-page__carousel-list" data-e2e="home-page-video-lists">
                <SortedVideosDecorated
                  sortedLists={sortedVideoLists}
                  containerWide={containerWide}
                  withRelatedVideos={withRelatedVideos}
                  withRating={withRating}
                />
                {navItems.map((navItem, index) => {
                  return (
                    <div key={'vl-' + index}>
                      <Link
                        data-e2e="home-channel-title"
                        className="ct-home-page__title"
                        to={navItem.model.url + '#top'}
                      >
                        {navItem.model.title}
                      </Link>
                      <Carousel
                        ariaLabel={navItem.model.title}
                        channelId={navItem.collectionId}
                        baseUrl={navItem.model.url}
                        withRelatedVideos={withRelatedVideos}
                      />
                    </div>
                  );
                })}
              </div>
            </ContentBox>
          ) : null}
        </div>
      </HomePageLoader>
    </PageDecorated>
  );
};

export * from './selectors';
export * from './actions';
export * from './reducer';
export * from './saga';
export * from './loader';
export * from './fragments/sorted-videos';
export * from './effects';
export * from './fragments/video-controls-menu';
export * from './video-carousel';
